import { render } from "./MemberSelector.vue?vue&type=template&id=2f6a5c2f"
import script from "./MemberSelector.vue?vue&type=script&lang=js"
export * from "./MemberSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__